import React from 'react';
import { FailedRecordsState, INITIAL_FAILED_RECORDS_STATE } from './recordsFailureReducer';

export const RecordsFailureContext = React.createContext<FailedRecordsState>(INITIAL_FAILED_RECORDS_STATE);
